<template>
  <Modal
    class="modalCaasIntro"
    :show-modal="showCaasIntroModal"
    @close="emit('cancel')"
  >
    <template #body>
      <video autoplay loop class="caas__video">
        <source src="@/assets/images/cg.mp4" type="video/mp4" />
      </video>
    </template>
  </Modal>
</template>
<script setup>
import Modal from '@/components/shared/Modal'
import { computed } from 'vue'
import { useStore } from 'vuex'

const emit = defineEmits(['cancel'])
const store = useStore()

const showCaasIntroModal = computed(() => store.state.modals.showCaasIntroModal)
</script>
<style lang="scss" scoped>
.modalCaasIntro {
  .caas__video {
    width: 100%;
  }
  .main__text {
    margin: 1rem 0;
  }

  .list {
    display: flex;
    align-items: center;
    justify-items: center;

    .icon {
      color: #2c3fd5;
      font-size: 18px;
      margin-left: 5px;
    }
  }
  .btnsWrapper {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
  }
  .info {
    margin: 2rem 0;
    font-style: italic;
  }
}
</style>
